var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"el-input"},[_c('label',{staticClass:"el-input__inner"},_vm._l((_vm.value),function(dept){return _c('el-tag',{key:dept.deptId,attrs:{"size":"medium","type":dept.isMain ? 'success' : 'default'}},[_vm._v(_vm._s(dept.deptName))])}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }